var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "lang"
  }, [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("标签名称")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("标签名称")
    },
    model: {
      value: _vm.form.signName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "signName", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.signName"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("字段名称")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100px"
    },
    model: {
      value: _vm.form.language,
      callback: function ($$v) {
        _vm.$set(_vm.form, "language", $$v);
      },
      expression: "form.language"
    }
  }, _vm._l(_vm.language, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1), _c("a-input", {
    staticStyle: {
      width: "180px",
      "margin-left": "10px"
    },
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("字段名称")
    },
    model: {
      value: _vm.form.languageValue,
      callback: function ($$v) {
        _vm.$set(_vm.form, "languageValue", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.languageValue"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("操作人")
    }
  }, [_c("a-input", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请输入") + _vm.$t("操作人")
    },
    model: {
      value: _vm.form.operatorName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "operatorName", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.operatorName"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("空值字段")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      "default-value": "zh",
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("空值字段类型")
    },
    model: {
      value: _vm.form.showEmpty,
      callback: function ($$v) {
        _vm.$set(_vm.form, "showEmpty", $$v);
      },
      expression: "form.showEmpty"
    }
  }, _vm._l(_vm.language, function (item) {
    return _c("a-select-option", {
      key: item.key,
      attrs: {
        value: item.key
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)], 1), _c("a-button", {
    staticClass: "marginR15 marginT10",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.onSearch
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "danger",
      "html-type": "submit"
    },
    on: {
      click: _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))]), _vm.isAuth("home.translateStore") ? _c("a-button", {
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: function ($event) {
        return _vm.openAddModal(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增")))]) : _vm._e(), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.tableData,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.tablePageChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (_, record, index) {
        return [_vm._v(_vm._s((_vm.pagination.current - 1) * _vm.pagination.pageSize + Number(index + 1)))];
      }
    }, {
      key: "operation",
      fn: function (text, record) {
        return [_vm.isAuth("home.translateEdit") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.openAddModal(record.id);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")) + " ")]) : _vm._e(), _vm.isAuth("home.translateDelete") ? _c("a-button", {
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.onDelete(record.id);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")) + " ")]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("add-modal", {
    attrs: {
      visible: _vm.addVisible,
      isEdit: _vm.isEdit
    },
    on: {
      save: _vm.onSearch,
      cancel: function ($event) {
        _vm.addVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };